import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ColorsModule } from '@plugins/client/colors/colors.module';
import { LetDirectiveModule } from '@plugins/client/directives/let-directive.module';
import { FormBaseControlComponent } from '@plugins/client/forms/form';
import { CancelIconComponent } from '@plugins/client/icons/cancel-icon';
import { CheckIconComponent } from '@plugins/client/icons/check-icon';
import { MinusIconComponent } from '@plugins/client/icons/minus-icon';
export type CheckboxIconType = 'times' | 'checkmark';

@Component({
  selector: 'plugins-checkbox',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ColorsModule,
    CheckIconComponent,
    CancelIconComponent,
    LetDirectiveModule,
    MinusIconComponent,
  ],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent extends FormBaseControlComponent {
  readonly icon = input<CheckboxIconType>('times');
  readonly indeterminate = input<boolean>(false);

  borderColor = 'rgb(121, 118, 118)';
  borderFocusColor = 'rgba(121, 118, 118, 0.5)';
  checked = false;

  constructor() {
    super();

    effect(() => {
      const indeterminate = this.indeterminate();

      if (!this.inputRef?.nativeElement) return;

      (this.inputRef.nativeElement as HTMLInputElement).indeterminate =
        indeterminate;
    });
  }

  override writeValue(value: unknown): void {
    this.control.patchValue(value, { emitEvent: false });
    this.cdRef.markForCheck();
  }
}
